export const REQUEST_EDIT_PIPELINE_MODAL_QA_NAME = 'requestEditPipeline'

export const REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE =
  'switchPipeline'

export const REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE = {
  No: 'no',
  Yes: 'yes',
}

export const REQUEST_EDIT_PIPELINE_MODAL_INITIAL_VALUES = {
  [REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE]:
    REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE.No,
}
